import {useRouterHistory} from 'coreUtils/adapters/router';

import {getIsInternalUrl, safeDecodeURI} from '../utils/url';

// TODO: should be imported from the router, but it's not exported
type TLocationDescriptor = {
	pathname?: string;
	search?: string;
	hash?: string;
	state?: any;
	key?: string;
};

const useHistory = () => {
	const history = useRouterHistory();

	const safePush = (value) => {
		try {
			history.push(value);
		} catch (e) {
			console.error(e);
		}
	};

	const safeReplace = (value) => {
		try {
			history.replace(value);
		} catch (e) {
			console.error(e);
		}
	};

	/**
	 * Simulate the behavior of history.push() but with the ability to handle external URLs
	 *
	 * @param {string | TLocationDescriptor} input - The URL to push or a location descriptor object
	 * @returns {void}
	 */
	const push = (input: string | TLocationDescriptor): void => {
		if (typeof input === 'string') {
			// If the input is a string URL
			if (getIsInternalUrl(input)) {
				safePush(input);
			} else {
				window.location.assign(safeDecodeURI(input));
			}
		} else {
			// If the input is a location descriptor object
			if (getIsInternalUrl(input.pathname || '')) {
				safePush(input);
			} else {
				window.location.assign(safeDecodeURI(input.pathname || ''));
			}
		}
	};

	return {
		...history,
		push,
		replace: safeReplace,
		go: history.go,
		goBack: history.goBack,
		goForward: history.goForward,
		listen: history.listen,
	};
};

export default useHistory;
